module.exports = __webpack_public_path__ + "static/008.thumb-bd98b1aa219730768e3fd777ddd737c7.jpg";